/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

/**
 * User session interface.
 *
 * Represents a user session including a user (jwt) token and expiry.
 */
export interface UserSessionInterface {
    token: string;
    refresh: string;
    expiry: number;
    verifier: string;
}

/**
 * User session class.
 *
 * Concrete implementation of the UserSessionInterface.
 */
export class UserSession implements UserSessionInterface {
    public token: string = '';
    public refresh: string = '';
    public expiry: number = 0;
    public verifier: string = '';
}

/**
 * User session state interface.
 *
 * Note: at the moment no additional user information is required so our state only contains user session configuration.
 */
export interface UserSessionStateInterface {
    session: UserSessionInterface;
}
